import React from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import { Images } from "../../assets/assets";
import { Helmet } from "react-helmet";

const RegisterMachine = () => {
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{"Register your Machine | SodaStream SA"}</title>
        <meta
          name="description"
          content={
            "Register your SodaStream machine and enjoy exclusive benefits. Stay updated and get the most out of your device!"
          }
        />
        <link
          rel="canonical"
          href=" https://www.sodastream.co.za/register-machine"
        />
      </Helmet>
      <Header
    
        textBackground="REGISTER"
        backgroundImg={"https://res.cloudinary.com/brabenjos/image/upload/v1696433365/sodastream/images/Page20Img.png"}
        subTitle="Register your product here."
        title="Register Your Machine"
      />
      <div className="relative min-h-[35rem] h-full w-full bg-[#EEEAE5] ">
        <div className="flex flex-col min-h-[45rem] md:flex-row">
  
          <iframe
            title="Register Your Machine"
            src="https://bravegroup.everlytic.net/public/forms/get/pID0m8kFsoq7Jne4/Zjk2MTRjNzcxMWY5YTIxZDkxYzIyMmI2ZjQzZjA5OGY4OGFmZWFjYg=="
            className="md:w-[50%] min-h-[65rem] md:p-10 border-none; overflow-x-auto overflow-y-none"
          ></iframe>
          <div className="p-10 md:w-[50%] md:flex items-center justify-center hidden">
            <img
              src={Images.Page20Img}
              alt="page 20"
              style={{ width: "100%" }}
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RegisterMachine;